import React, { useState, useEffect } from "react";

import api, { API_URL, BACKEND_URL } from "./util/api";


export default function ExcoPage() {

    const [zoomImage, setZoomImage] = useState(null);
    const [selectedMember, setSelectedMember] = useState(null);
    const [loadedImages, setLoadedImages] = useState({});
    const [members, setMembers] = useState([]);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchMembers();
    }, []);

    const fetchMembers = async () => {

        try {

            const res = await api.get(API_URL + "/excos");

            if (res.data.status) {
                setMembers(res.data.members);
            }

        } catch (error) {
            console.log(error);
        }

        setLoading(false);
    };

    const closeZoom = (e) => {
        if (e.target.className === "zoom-overlay") {
            /*  setZoomImage(null); */
            setSelectedMember(null);

        }
    };

    return (
        <>
            {selectedMember && (
                <div
                    className="zoom-overlay"
                    onClick={closeZoom}
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100vh",
                        background: "rgba(0,0,0,0.85)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999,
                        padding: "20px"
                    }}
                >
                    <div
                        style={{
                            background: "#fff",
                            borderRadius: "20px",
                            maxWidth: "500px",
                            width: "100%",
                            padding: "25px",
                            textAlign: "center",
                            animation: "fadeInUp 0.4s ease-in-out",
                            position: "relative"
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Close Button */}
                        <button
                            onClick={() => setSelectedMember(null)}
                            style={{
                                position: "absolute",
                                top: "10px",
                                right: "15px",
                                background: "none",
                                border: "none",
                                fontSize: "22px",
                                cursor: "pointer"
                            }}
                        >
                            ✕
                        </button>

                        <img
                            src={BACKEND_URL + selectedMember.image}
                            alt={selectedMember.name}
                            style={{
                                width: "100%",
                                height: "300px",
                                objectFit: "cover",
                                borderRadius: "15px",
                                marginBottom: "20px"
                            }}
                        />

                        <h2 style={{ fontSize: "24px", fontWeight: "700" }}>
                            {selectedMember.name}
                        </h2>

                        <h3 style={{ color: "#777", marginBottom: "15px" }}>
                            {selectedMember.position}
                        </h3>

                        {/* EXTRA DETAILS */}
                        <p style={{ fontSize: "15px", lineHeight: "1.6", color: "#555" }}>
                            {selectedMember.bio || "No additional information available."}
                        </p>

                        {/* You can add more fields if available */}
                        {selectedMember.email && (
                            <p><strong>Email:</strong> {selectedMember.email}</p>
                        )}

                        {selectedMember.phone && (
                            <p><strong>Phone:</strong> {selectedMember.phone}</p>
                        )}
                    </div>
                </div>
            )}

            <section style={{ marginTop: "2cm" }}>
                <div style={styles.page}>
                    <h1 style={{ ...styles.name, fontSize: "36px", marginBottom: "30px" }}> </h1>

                    <style>{`

          @keyframes shimmer {
            0% { background-position: -468px 0; }
            100% { background-position: 468px 0; }
          }

          .skeleton {
            animation-duration: 1.4s;
            animation-fill-mode: forwards;
            animation-iteration-count: infinite;
            animation-name: shimmer;
            animation-timing-function: linear;
            background: linear-gradient(
              to right,
              #eeeeee 8%,
              #dddddd 18%,
              #eeeeee 33%
            );
            background-size: 800px 104px;
          }

          @keyframes fadeInUp {
            from { opacity: 0; transform: translateY(30px); }
            to { opacity: 1; transform: translateY(0); }
          }

          .lazy-img {
            filter: blur(8px);
            opacity: 0;
            transition: opacity 0.6s ease, filter 0.6s ease;
          }

          .lazy-img.loaded {
            filter: blur(0);
            opacity: 1;
          }

          @media (max-width:768px){
            .member-card{
              width:90%!important;
            }
          }

          `}</style>

                    <div style={styles.membersContainer}>

                        {loading &&
                            [...Array(8)].map((_, i) => (
                                <div key={i} style={styles.card}>
                                    <div className="skeleton" style={{ height: 280, borderRadius: 20 }}></div>
                                    <div className="skeleton" style={{ height: 20, marginTop: 15 }}></div>
                                    <div className="skeleton" style={{ height: 15, width: "60%", margin: "10px auto" }}></div>
                                </div>
                            ))
                        }

                        {!loading && members.map((m, index) => (

                            <div key={index} className="member-card" style={styles.card}>

                                <img
                                    src={BACKEND_URL + m.image}
                                    alt={m.name}
                                    loading="lazy"
                                    onLoad={() =>
                                        setLoadedImages((prev) => ({ ...prev, [index]: true }))
                                    }
                                    onClick={() => setSelectedMember(m)}
                                    className={`lazy-img ${loadedImages[index] ? "loaded" : ""}`}
                                    style={styles.image}
                                />

                                <h2 style={styles.name}>{m.name}</h2>
                                <h3 style={styles.role}>{m.position}</h3>

                            </div>

                        ))}

                    </div>
                </div>
            </section>
        </>
    );
}

const styles = {

    page: {
        width: "100%",
        minHeight: "100vh",
        background: "linear-gradient(135deg,#f5f5f5,#ffffff)",
        padding: "50px 20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },

    membersContainer: {
        width: "100%",
        maxWidth: "1200px",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: "35px",
    },

    card: {
        width: "280px",
        background: "#fff",
        borderRadius: "20px",
        padding: "25px",
        textAlign: "center",
        animation: "fadeInUp 1.2s ease-in-out",
        boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
        cursor: "pointer"
    },

    image: {
        width: "100%",
        height: "280px",
        objectFit: "cover",
        borderRadius: "20px",
        marginBottom: "20px",
    },

    name: {
        fontSize: "22px",
        fontWeight: "700",
        marginBottom: "8px",
    },

    role: {
        fontSize: "16px",
        color: "#777",
    },

};